module.exports = __webpack_public_path__ + "img/shouru.d43130b0.png";